import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useFetch } from "@/lib/content";
import BrandMark from "@/components/site/BrandMark";

const NAV = [
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/frameworks", label: "Frameworks" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/insights", label: "Insights" },
  { to: "/media", label: "Media" },
  { to: "/contact", label: "Contact" },
];

export default function SiteFooter() {
  const { data: settings } = useFetch("/content/settings");

  return (
    <footer data-testid="site-footer" className="bg-obsidian text-paper">
      <div className="mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <p className="font-serif text-4xl font-medium leading-[1.1] tracking-tight md:text-6xl">
              Let&apos;s build the machine
              <br />
              behind your ambition<span className="text-progress">.</span>
            </p>
            <Link
              to="/book"
              data-testid="footer-cta"
              className="group mt-10 inline-flex items-center gap-3 bg-progress px-7 py-4 text-sm font-bold uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:bg-progress-dark"
            >
              Book a Discovery Call
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
          <div className="grid gap-10 md:col-span-5 md:grid-cols-2">
            <nav aria-label="Footer" className="flex flex-col gap-3">
              <p className="text-[13px] font-bold uppercase tracking-[0.2em] text-paper/40">Navigate</p>
              {NAV.map((l) => (
                <Link key={l.to} to={l.to} className="text-sm text-paper/80 transition-colors hover:text-progress">
                  {l.label}
                </Link>
              ))}
            </nav>
            <div className="flex flex-col gap-3">
              <p className="text-[13px] font-bold uppercase tracking-[0.2em] text-paper/40">Contact</p>
              <a href={`mailto:${settings?.contact_email || "hello@renbsolutions.com"}`} className="text-sm text-paper/80 transition-colors hover:text-progress">
                {settings?.contact_email || "hello@renbsolutions.com"}
              </a>
              <a href={`tel:${(settings?.phone || "+919920820106").replace(/\s/g, "")}`} className="text-sm text-paper/80 transition-colors hover:text-progress">
                {settings?.phone || "+91 99208 20106"}
              </a>
              <p className="text-sm leading-relaxed text-paper/50">{settings?.address}</p>
            </div>
          </div>
        </div>
        <div className="mt-20 flex flex-col gap-3 border-t border-paper/10 pt-8 text-[12px] text-paper/40 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col items-start gap-3">
            <BrandMark footer linkTo={false} />
            <p data-testid="footer-tagline" className="text-[13px] font-medium tracking-wide text-paper/70">
              We help companies grow.
            </p>
          </div>
          <p>© {new Date().getFullYear()} RenB Solutions · Where Process Meets Progress · Mumbai</p>
        </div>
      </div>
    </footer>
  );
}
